import { getStoredToken } from '@/auth';

export const defaultHeaders = (headers?: HeadersInit): HeadersInit => {
  return {
    ...headers,
    Authorization: `Bearer ${getStoredToken()}`,
  };
};
